import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faCartShopping,
	faCheck,
	faMoneyBillWave,
	faShieldHalved,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";

const BENEFIT_ICONS: IconDefinition[] = [faCartShopping, faShieldHalved, faCheck, faMoneyBillWave];

interface PaymentBenefitsProps {
	benefits: string[];
}

function PaymentBenefits(prop: PaymentBenefitsProps) {
	const { benefits } = prop;
	return (
		<div className="mt-8 grid gap-x-6 gap-y-4 sm:grid-cols-2">
			{benefits.map((benefit, i) => (
				<div key={benefit} className="flex items-center gap-3">
					<span
						className="grid h-8 w-8 shrink-0 place-items-center rounded-full"
						style={{
							background: "color-mix(in srgb, var(--brand-2) 16%, transparent)",
							color: "var(--brand-2)",
						}}
					>
						<Icon icon={BENEFIT_ICONS[i % BENEFIT_ICONS.length]} size={16} />
					</span>
					<span className="text-sm font-medium">{benefit}</span>
				</div>
			))}
		</div>
	);
}

export default PaymentBenefits;
